import * as React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface CountryCode {
  code: string;
  name: string;
  dialCode: string;
  flag: string;
}

const countryCodes: CountryCode[] = [
  { code: "us", name: "United States", dialCode: "+1", flag: "🇺🇸" },
  { code: "gb", name: "United Kingdom", dialCode: "+44", flag: "🇬🇧" },
  { code: "ae", name: "United Arab Emirates", dialCode: "+971", flag: "🇦🇪" },
  { code: "au", name: "Australia", dialCode: "+61", flag: "🇦🇺" },
  { code: "ca", name: "Canada", dialCode: "+1", flag: "🇨🇦" },
  { code: "cn", name: "China", dialCode: "+86", flag: "🇨🇳" },
  { code: "de", name: "Germany", dialCode: "+49", flag: "🇩🇪" },
  { code: "fr", name: "France", dialCode: "+33", flag: "🇫🇷" },
  { code: "in", name: "India", dialCode: "+91", flag: "🇮🇳" },
  { code: "jp", name: "Japan", dialCode: "+81", flag: "🇯🇵" },
  { code: "sg", name: "Singapore", dialCode: "+65", flag: "🇸🇬" },
];

interface CountrySelectProps {
  value?: string;
  onChange: (value: string) => void;
}

export function CountrySelect({ value, onChange }: CountrySelectProps) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger>
        <SelectValue placeholder="Select" />
      </SelectTrigger>
      <SelectContent onWheel={(e) => e.stopPropagation()}>
        <div className="max-h-40 overflow-y-auto">
          {countryCodes.map((country) => (
            <SelectItem key={country.code} value={country.dialCode}>
              <div className="flex items-center">
                <span className="mr-2">{country.flag}</span>
                <span>{country.dialCode}</span>
              </div>
            </SelectItem>
          ))}
        </div>
      </SelectContent>
    </Select>
  );
}
